<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"\n"' class="col-lg-6 col-sm-12 m-0 p-0 mx-auto mb-2" >
                <template #default>   <m-video v-bind='{...{"controls":false,"videoSrc":"https:\/\/api.geramyan.com\/storage\/bargiri\/Signup.mp4","autoplay":true,"muted":true,"loop":true,"poster":null},...{}}' :style='"object-fit: cover;\nborder-radius: 25px;\n\n\n"' class="col-lg-12 m-0 p-0  shadow" ></m-video></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-12 bg-primary py-3  text-center " >
                <template #default>   <m-h5 v-bind='{...{},...{}}' :style='""' class="text-white" >
                <template #default>ورود   </template>
                </m-h5></template>
                </m-div><m-login-1 v-bind='{...{"image":null,"showPanels":false,"imageParentClass":"col-lg-6 d-none d-lg-block","defaultPanel":2},...{}}' :style='""' class="authentication-forms" >
                <template #classic-login-p-1-bottom>   </template>
                
                <template #classic-login-p-1-top>   </template>
                
                <template #two-step-login-p-1-bottom>   </template>
                
                <template #two-step-login-p-1-top>   </template>
                </m-login-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mVideo from '@moeinmdn/miw-alpha-components/src/package/Tags/Video'; import mH5 from '@moeinmdn/miw-alpha-components/src/package/Tags/H5'; import mLogin1 from '@moeinmdn/miw-alpha-components/src/package/Authentication/Login/Login1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mVideo,mH5,mLogin1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
